import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {fetchMediaComments, resetMediaComments} from "../../../creators/media.comments";
import {createSubComment, updateSubComment} from "../../../creators/comments.subComment";
import Comment from './components/Comment';
import _ from 'lodash';
import {createMediaComment, deleteMediaComment, updateMediaComment} from "../../../creators/media.comment";
import {SpinLoader} from "../Loader";

import createLink from "../../../libs/createLink";
import {reportMediaComment} from "../../../creators/report";
import CommentEditor from "./components/CommentEditor/CommentEditor";
import {fetchUserFriends} from "../../../creators/user.friends";
import {Can} from "../../../ability-context";

class MediaComments extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            parentIdMedia: this.props.mediaId || 0,
            page: 1,
            limit: 10,
            sort: "-createdAt"
        };
        this.initialSubCommentAnswer = {
            owner: {},
            commentId: ""
        };
        this.state = {
            edit : {},
            isNextComment: false,
            showSubComment: 0,
            filter: this.filter,
            subCommentAnswer: this.initialSubCommentAnswer,
            isAnsweringComment: false,
        };
        this.fetchComments = this.fetchComments.bind(this);
        this.commentsNext = this.commentsNext.bind(this);
        this.updateMediaComment = this.updateMediaComment.bind(this);
        this.deleteMediaComment = this.deleteMediaComment.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleSubCommentAnswer = this.handleSubCommentAnswer.bind(this);
        this.resetSubCommentAnswer = this.resetSubCommentAnswer.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);

        this.fetchComments(this.state.filter);
        if(this.props.currentUserInitialized && this.props.currentUserId && !this.props.userFriendsInitialized){
            this.props.fetchUserFriends(this.props.currentUserId);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mediaId !== this.props.mediaId) {
            this.props.resetMediaComments();
            this.fetchComments(this.state.filter, false);
        }
    }

    componentWillUnmount() {
        this.props.resetMediaComments();
    }

    fetchComments(filter, more) {
        filter = {...filter};
        this.props.fetchMediaComments(this.props.mediaId, filter, more);
    }

    commentsNext() {
        let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.fetchComments(newFilter,true);
    }

    updateMediaComment(id, value) {
        this.props.updateMediaComment(this.props.mediaId, id, {content: value});
    }

    deleteMediaComment(id) {
        this.props.deleteMediaComment(this.props.mediaId, id);
    }

    handleReport(id, message){
        this.props.reportMediaComment(this.props.mediaId, id, {message})
    }

    handleSubCommentAnswer(commentId, ownerOfSubComment){
        this.setState({subCommentAnswer: {
            owner: ownerOfSubComment,
            commentId
        }});
    }

    resetSubCommentAnswer() {
        this.setState({subCommentAnswer: this.initialSubCommentAnswer, isAnsweringComment: false});
    }

    handleSubmit(value) {
        if(this.state.subCommentAnswer.commentId){
            this.props.createSubComment(this.props.commentType, this.props.mediaId, this.state.subCommentAnswer.commentId, value);
            this.setState({isAnsweringComment: true}, () => this.resetSubCommentAnswer());
        } else {
            this.props.createMediaComment(this.props.mediaId, value);
            this.setState({subCommentAnswer: this.initialSubCommentAnswer})
        }
    }

    handleSubmitEdit({
                         parentId,
                         parentCommentId,
                         commentId,
                        commentType,
                     }, contentState) {
        if (parentCommentId) {
            this.props.updateSubComment(commentType, parentId, parentCommentId, commentId, contentState);
        }
        else {
            this.props.updateMediaComment(parentId, commentId, contentState);
        }

        this.setState({edit:{}});
    }

    handleEdit({
        parentId,
        parentCommentId,
        commentId,
        text,
        mentions,
        commentType
               }){
        this.setState({edit : {
            parentId,
            parentCommentId,
            commentId,
            text,
            mentions,
                commentType
        }});
}

    onFocus = () => {
        if(typeof this.props.enableArrow === "function"){
            this.props.enableArrow(false);
        }
    };
    onBlur = () => {
        if(typeof this.props.enableArrow === "function"){
            this.props.enableArrow(true);
        }
    };

    render() {
        let canOptions = {subject : this.props.media, modelName : "Comment", action : "create", passThrough : true};
        let comments = Array.isArray(this.props.mediaComments) ? [...this.props.mediaComments] : [];
        return (
            <Fragment>
                <div className="column media-comments-container">
                    <div className="comments">
                        <div className="comments-list">
                            {!this.props.mediaCommentsInitialized && _.times(5).map((item, index) => (
                                <Comment key={index} commentsInitialized={false}/>
                            ))}
                            {this.props.mediaCommentsInitialized && !this.props.mediaCommentsLoading && this.props.mediaCommentsTotal === 0 && (
                                <div className={"no-content"}>Aucun commentaire</div>
                            )}
                            {comments.map((comment) => (
                                <Comment
                                    key={comment._id}
                                    {...comment}
                                    handleEdit={this.handleEdit}
                                    currentUser={this.props.currentUser}
                                    parentId={this.props.mediaId}
                                    showSubComment={this.state.showSubComment}
                                    commentsInitialized={this.props.mediaCommentsInitialized}
                                    deleteComment={this.deleteMediaComment}
                                    updateComment={this.updateMediaComment}
                                    handleReport={this.handleReport}
                                    handleSubCommentAnswer={this.handleSubCommentAnswer}
                                    commentType={this.props.commentType}
                                    subCommentAnswer={this.state.subCommentAnswer}
                                    isAnsweringComment={this.state.isAnsweringComment}
                                />
                            ))}
                            {!this.props.mediaCommentsLoading && this.props.mediaCommentsMore && (
                                <div className="more-comments" onClick={() => this.commentsNext()}>
                                    Voir plus de commentaires
                                </div>
                            )}
                            {this.props.mediaCommentsLoading && this.props.mediaCommentsMore && (
                                <div className="more-comments loading" onClick={() => this.commentsNext()}>
                                    <SpinLoader className={"small"}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {_.get(this.props,"media.comment.allowed") ? (
                    <Can {...canOptions}>
                        {can=>(
                            <CommentEditor
                                mentions={this.props.userFriends}
                                onSubmit={this.handleSubmit}
                                onSubmitEdit={this.handleSubmitEdit}
                                onBlur={()=>this.onBlur()}
                                onFocus={()=>this.onFocus()}
                                onCancelRespond={()=>{
                                    this.setState({subCommentAnswer: this.initialSubCommentAnswer})
                                }}
                                onCancelEdit={()=>{
                                    this.setState({edit: {}})
                                }}
                                edit={this.state.edit}
                                respondMention={this.state.subCommentAnswer.owner}
                                cannot={!can}
                            />)}
                    </Can>
                    /*<div className={"avatar-input-comment"}>
                        <Avatar gender={_.get(this.props.currentUser, 'profile.gender')}
                                avatar={_.get(this.props.currentUser, 'profile.avatar')}/>
                        <InputPost sendBtnIcon={true}
                                   handleSubmit={this.handleSubmit}
                                   emoji={true}
                                   editorStyle={"add-comment"}
                                   subCommentAnswer={this.state.subCommentAnswer}
                                   loading={this.props.mediaCommentSubmitting}
                                   userFriends={this.props.userFriends}
                                   callback={() => this.reloadComments(this.props.mediaId, this.props.mediaType)}
                                   enterSubmit={true}
                                   onBlur={()=>this.onBlur()}
                                   onFocus={()=>this.onFocus()}
                                   canOptions={{subject : this.props.media, modelName : "Comment", action : "create", passThrough : true}}
                        />
                    </div>*/

                ) : (
                    <div className="close-comments">
                        {this.props.currentUserInitialized ? "Commentaires fermés par l’auteur" : <span>Veuillez vous <Link
                            to={createLink("signin")}>connecter</Link> pour publier un commentaire</span>}
                    </div>
                )}
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        mediaComments: state.mediaComments.data,
        mediaCommentsLoading: state.mediaComments.loading,
        mediaCommentSubmitting: state.mediaComments.submitting,
        mediaCommentsInitialized: state.mediaComments.initialized,
        mediaCommentsTotal: state.mediaComments.total,
        mediaCommentsMore: state.mediaComments.more,

        mediaComment: state.mediaComment.data,
        mediaCommentLoading: state.mediaComment.loading,
        userFriends: state.userFriends.data,
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        userFriendsInitialized: state.userFriends.initialized,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMediaComments,
    resetMediaComments,
    fetchUserFriends,
    createMediaComment,
    updateMediaComment,
    updateSubComment,
    deleteMediaComment,
    reportMediaComment,
    createSubComment,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MediaComments);
